import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import { AppWrapper } from "./components/common/PageMeta";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  ApolloLink,
  HttpLink,
} from "@apollo/client";

import { SnackbarCloseButton } from "./components/SnackbarCloseButton";
import { SnackbarProvider } from "notistack";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { FormDataProvider } from "./context/FormDataContext";
import { GetDataProvider } from "./context/GetDataContext";
import { LoadScript } from "@react-google-maps/api";
import { config } from "./utils/constants";
import { FilterDataProvider } from "./context/TableDataContext";

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// Create HttpLinks for each endpoint
const getEditDataLink = new HttpLink({
  uri: `${config.baseURL}/graphql/geteditdata`,
});
const loadDispatchLink = new HttpLink({
  uri: `${config.baseURL}/graphql/load_dispatch`,
});

// ApolloLink to route requests based on context.clientName
const link = ApolloLink.split(
  (operation) => operation.getContext().clientName === "loadDispatch",
  loadDispatchLink,
  getEditDataLink,
);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppWrapper>
        <ThemeProvider>
          <QueryClientProvider client={queryClient}>
            <ApolloProvider client={client}>
              <SnackbarProvider
                action={(key) => (
                  <SnackbarCloseButton key={key as unknown as string} />
                )}
                autoHideDuration={2000}
                maxSnack={1}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                hideIconVariant
              >
                <FormDataProvider>
                  <GetDataProvider>
                    <FilterDataProvider>
                      <LoadScript
                        googleMapsApiKey={
                          process.env.REACT_APP_GOOGLE_MAPS_API_KEY!
                        }
                        libraries={["places"]}
                      >
                        <App />
                      </LoadScript>
                    </FilterDataProvider>
                  </GetDataProvider>
                </FormDataProvider>
              </SnackbarProvider>
            </ApolloProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </AppWrapper>
    </Provider>
  </React.StrictMode>,
);

// Usage in components:
// useQuery(MY_QUERY, { context: { clientName: "loadDispatch" } })
// useMutation(MY_MUTATION, { context: { clientName: "loadDispatch" } })

reportWebVitals();
